/* istanbul ignore file */
import { UpdateForm, UpdateFormProps } from 'framework/form';
import { useEmployeeNoteService } from 'domain/shared/employee';
import { UpdateTimelineItemLayout } from 'framework/ui/timeline';
import NoteForm from 'domain/people/employee/Timeline/note/form/NoteForm';

interface UpdateNoteFormProps extends Omit<UpdateFormProps, 'submitFormFunc'> {
  onCancel: () => void;
}

const UpdateNoteForm = ({ getDataFunc, onCancel, ...props }: UpdateNoteFormProps) => {
  const { getValidationSchema, update } = useEmployeeNoteService();

  return (
    <UpdateForm
      getDataFunc={getDataFunc}
      submitFormFunc={update}
      getValidationSchemaFunc={getValidationSchema}
      {...props}
    >
      <UpdateTimelineItemLayout onCancel={onCancel}>
        <NoteForm />
      </UpdateTimelineItemLayout>
    </UpdateForm>
  );
};

export default UpdateNoteForm;
